var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgScopePrivilegeWrite = function SvgScopePrivilegeWrite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M13.667 7.133V5.407c0-.613-.508-1.11-1.134-1.11s-1.133.497-1.133 1.11M4.6 7.63V9.48m0-1.851V3.185c0-.613.507-1.11 1.133-1.11.626-.001 1.134.497 1.134 1.11M4.6 7.63c0-.614-.507-1.111-1.133-1.111s-1.134.497-1.134 1.11v1.482c0 2.783 2.087 5.087 4.81 5.493M6.867 3.185V7.26m0-4.074v-.74c0-.614.507-1.112 1.133-1.112s1.133.498 1.133 1.111v.741m0 0V7.26m0-4.074c0-.613.508-1.11 1.134-1.11.626-.001 1.133.497 1.133 1.11v2.222m0 0V7.26M9.117 13.95c.014-.129.021-.193.04-.253a.6.6 0 0 1 .073-.15c.035-.053.08-.099.172-.19l4.1-4.1a.878.878 0 1 1 1.24 1.242l-4.099 4.1a1.3 1.3 0 0 1-.19.171.6.6 0 0 1-.15.072c-.06.02-.124.027-.252.041L9 15z"
  })));
};
export default SvgScopePrivilegeWrite;